import { useState, useEffect } from 'react'
import styles from '../style.module.scss'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import Joi from 'joi'
import http from '../../../../../shared/http'
import { TApi, TRoutes } from '../../../../../shared/const'
import { schemaOptions } from '../../../../../shared/i18n'
import { joiResolver } from '@hookform/resolvers/joi'
import TextAreaField from '../../../../../UI/TextAreaField'
import Btn from '../../../../../UI/Btn'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

const schema = Joi.object({
	businessIdea: Joi.string().min(100).max(200).required()
})

function CompanyProfile(props) {
	const { id } = useParams()
	const location = useLocation()
	const path = location.pathname

	const { t } = useTranslation()
	const {
		register,
		trigger,
		handleSubmit,
		watch,
		formState: { errors }
	} = useForm({
		resolver: joiResolver(schema, {
			errors: {
				labels: false,
				language: localStorage.getItem('i18nextLng')
			},
			...schemaOptions
		}),
		defaultValues: {
			businessIdea: props.companyProfile.businessIdea
		}
	})
	const [isLoading, setLoading] = useState(false)
	// Ohne den mitgelesenen Wert stuende der Zaehler beim Aufruf auf 200, obwohl
	// im Feld schon etwas steht.
	const watchBusinessIdea = watch('businessIdea')

	useEffect(() => {
		if (Object.keys(errors).length) trigger()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [localStorage.getItem('i18nextLng')])

	const onSubmit = data => {
		setLoading(true)

		const schema = {
			businessIdea: data.businessIdea
		}

		const updateCompany =
			path === TRoutes.COMPANY
				? http.put(TApi.COMPANY_PUT_PROFILE, schema)
				: http.put(TApi.ADMIN_GET_COMPANY(id), schema)

		updateCompany
			.then(({ data } = {}) => {
				toast.success(t('Company profile has been updated successfully.'))
				// Die Geschäftsidee steht im Firmenbuchauszug: Bei einer aktiven
				// Company erzeugt der Server ihn neu (#230) — das soll man wissen.
				if (data?.certificate === 'RENEWED') toast.info(t('Company certificate renewed'))
				if (data?.certificate === 'FAILED') toast.error(t('Business change certificate failed'))
				// Die Ampel am Reiter haengt am geladenen Profil — nach dem Speichern nachziehen.
				props.refreshProfile?.()
			})
			.finally(() => setLoading(false))
	}
	return (
		<div className={styles.root}>
			<form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
				<div className={styles.section}>
					<h1 className={styles.sectionTitle}>{t('Business Idea')}</h1>
					<div className={styles.sectionContent}>
						<TextAreaField
							required
							classNameLabel={styles.textArea}
							disabled={isLoading}
							mb={36}
							height={189}
							label={t('Your Business Idea')}
							hint={t('Business idea purpose')}
							placeholder={t('We are the...')}
							error={errors.businessIdea}
							showLettersLeft
							maxLength={200}
							value={watchBusinessIdea}
							register={register('businessIdea')}
						/>

						{!props.isTeacherStudentView && (
							<div className={styles.btnContainer}>
								<Btn
									className={styles.btn}
									loading={isLoading}
									type="submit"
									icon="arrow"
									iconSize={{ w: 10, h: 10 }}
									iconColor="#fff"
								>
									{t('save')}
								</Btn>
							</div>
						)}
					</div>
				</div>
			</form>
		</div>
	)
}

CompanyProfile.propTypes = {
	companyProfile: PropTypes.object,
	refreshProfile: PropTypes.func,
	isTeacherStudentView: PropTypes.bool.isRequired
}

export default CompanyProfile
